<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <!--      <a-button
        type="primary"
        shape="round"
        icon="plus"
        :style="{ float: 'right', marginTop: '19px' }"
        @click="editAndAdd"
      >
        新增问题
      </a-button> -->
      <a-dropdown placement="bottomLeft">
        <a-button
          type="primary"
          shape="round"
          icon="plus"
          :style="{ float: 'right', marginTop: '19px' }"
        >
          新增
        </a-button>
        <a-menu slot="overlay">
          <a-menu-item key="0" @click="editAndAdd"> 新增题型 </a-menu-item>
          <a-menu-item key="3" @click="importShow"> 导入题型 </a-menu-item>
        </a-menu>
      </a-dropdown>
      <div
        style="float: right; height: 70px; line-height: 70px"
        class="table-search-container1"
      >
        <span>考试等级：</span>
        <a-cascader
          style="width: 250px; margin: 0 10px 0 0"
          :options="options"
          @change="changeSelect1"
          :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
          placeholder="请选择考试等级"
        />

        <span>难度：</span>
        <a-select
          style="width: 142px; margin: 0 10px 0 0"
          v-model="difficulty"
          placeholder="请选择难度"
          @change="changeSelect22"
        >
          <a-select-option :value="0"> 全部 </a-select-option>
          <a-select-option :value="1"> 容易 </a-select-option>
          <a-select-option :value="2"> 中等 </a-select-option>
          <a-select-option :value="3"> 困难 </a-select-option>
        </a-select>
        <span>题目类型：</span>
        <a-select
          style="width: 142px; margin: 0 10px 0 0"
          v-model="actualType"
          placeholder="请选择题目类型"
          @change="changeSelect"
        >
          <a-select-option
            v-for="item in questionType"
            :key="item.key"
            :value="item.key"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
        <span>状态：</span>
        <a-select
          style="width: 142px; margin: 0 10px 0 0"
          v-model="status"
          placeholder="请选择状态"
          @change="changeSelect3"
        >
          <a-select-option :value="0"> 全部 </a-select-option>
          <a-select-option :value="1"> 启用 </a-select-option>
          <a-select-option :value="2"> 禁用 </a-select-option>
        </a-select>
        <a-input-search
          placeholder="搜索"
          style="width: 225px; margin-right: 10px"
          :allowClear="true"
          @search="(value) => onSearch(value)"
        />
      </div>
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="tableData"
        :loading="loading"
        :row-key="(record) => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: (total) => `共${total}条`,
        }"
        @change="changePage"
      >
        <template slot="difficulty" slot-scope="text, record">
          <div class="" v-if="record.difficulty === 1">容易</div>
          <div class="" v-if="record.difficulty === 2">中等</div>
          <div class="" v-if="record.difficulty === 3">困难</div>
        </template>
        <template slot="operation" slot-scope="text, record">
          <a href="javascript:;" @click="() => editAndAdd(record)">编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            :text="record.data.status === 1 ? '禁用' : '启用'"
            :alert-title="
              record.data.status === 1 ? '确定禁用？' : '确定启用？'
            "
            @onDelete="() => onConfirm(record)"
          />
          <a-divider type="vertical" />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
    <question-modal
      ref="formRef"
      :visible="visible"
      :title="title"
      :optionsData="options"
      :select-is-disabled="selectIsDisabled"
      @onCancel="onCancel"
    >
      <form-button
        :btn-is-loading="btnIsLoading"
        @onCancel="onCancel"
        @onSubmit="onSubmit"
      />
    </question-modal>
    <a-modal
      class="client-modal-wrapper hospital-modal"
      :destroy-on-close="true"
      width="1400px"
      :mask-closable="false"
      :visible="ImportReadhospitalVisible"
      :footer="null"
      title="导入题型"
      @cancel="onCancel1"
    >
      <div style="display: inline; margin-right: 10px">
        试题等级
        <a-cascader
          :options="options"
          @change="changeSelect2"
          style="width: 250px"
          :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
          placeholder="请选择试题等级"
        />
      </div>

      <div style="display: inline">
        <a-upload
          name="upload"
          style="margin-right: 20px"
          :with-credentials="false"
          :disabled="!allowUpload"
          :data="{ fileType: 'file' }"
          :action="`${uploadUrl}fileup/upload`"
          @change="(event) => importDoctors(event)"
        >
          <a-tooltip
            placement="bottom"
            :style="{ cursor: allowUpload ? 'pointer' : 'not-allowed' }"
          >
            <template slot="title">
              <span
                >提示：{{
                  allowUpload ? "按照模板格式导入" : "请选择试题等级"
                }}</span
              >
            </template>
            <a-button> <a-icon type="upload" /> 批量导入题型 </a-button>
          </a-tooltip>
        </a-upload>
      </div>
      <div class="upload-notice">
        支持上传xls和xlsx格式文件，不超过10M，<a
          href="javascript:;"
          @click="xiazai"
          >点击下载Excel模板</a
        >。请按模板格式录入数据，格式错误将导致导入失败。 【本次导入成功
        {{ successNum }} 条，失败 {{ failNum }} 条；已存在 {{ hadNum }} 条】
      </div>
      <div>
        <a-table
          :scroll="{ y: 500, x: 1100 }"
          :columns="columns1"
          :data-source="data1"
          :loading="loading1"
          :row-key="(record) => record.line"
          :pagination="false"
          class="yc"
        >
          <template slot="error_msg" slot-scope="text, record">
            <div v-if="record.error == true" style="color: red">
              {{ record.error_msg }}
            </div>
            <div v-if="record.error !== true">{{ record.error_msg }}</div>
          </template>
        </a-table>
      </div>
    </a-modal>
  </div>
</template>
<script>
const uuidv1 = require("uuid/v1");
import { columns, columns1 } from "./data/index";
import { getType, getCompany } from "./utils/dealTable";
import QuestionModal from "./modal/index.vue";
export default {
  components: {
    QuestionModal,
  },
  data() {
    return {
      options: [],
      difficulty: 0,
      searchquestions_level: [],
      actualType: 0,
      status: 0,
      questionType: [
        { key: 0, name: "全部" },
        { key: 4, name: "问答题" },
        { key: 1, name: "单选题" },
        { key: 2, name: "多选题" },
        { key: 3, name: "判断题" },
      ],
      allowUpload: false,
      successNum: "-",
      failNum: "-",
      hadNum: "-",
      data1: [],
      total1: 0,
      loading1: false,
      selectData: [],
      columns,
      columns1,
      tableData: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: true,
      visible: false,
      title: "",
      questionId: undefined,
      btnIsLoading: false,
      selectIsDisabled: false,
      company_id: null,
      companyData: [],
      ImportReadhospitalVisible: false,
      questions_level: [],
    };
  },
  mounted() {
    this.getpaperCategory();
    this.getCompanyList();
    // 获取表格数据
    // this.getTableData({ page: this.current, pageSize: this.pageSize,company_id: this.company_id });
  },
  methods: {
    async getpaperCategory() {
      this.loading1 = true;
      let result = await this.$http.post("/paperCategory/types", {});
      if (result.data.status === 1) {
        this.options = result.data.data;
      }
      this.loading1 = false;
    },
    changeSelect2(key) {
      this.allowUpload = true;
      this.questions_level = key;
    },
    async importDoctors(event) {
      if (event.file.response && event.file.response.status === 0) {
        this.$message.warning(event.file.response.msg);
      }
      if (event.file.response && event.file.response.status === 1) {
        let id = event.file.response.data.id;

        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let res = await this.$http.post("/QuestionBank/bankImport", {
          id,
          questions_level: this.questions_level,
        });
        loading.close();
        if (res.data.status === 1) {
          this.successNum = res.data.data.successNum;
          this.failNum = res.data.data.failNum;
          this.hadNum = res.data.data.hadNum;
          this.getTableData1({
            page: this.current,
            pageSize: this.pageSize,
            id: id,
          });
          this.$message.success("操作成功！");
        }
      }
    },
    async getTableData1(params) {
      this.loading1 = true;
      let result = await this.$http.post(
        "/QuestionBank/bankImportRead",
        params
      );
      if (result.data.status === 1) {
        this.loading1 = false;
        this.total1 = result.data.data.count;
        let data = result.data.data;

        this.data1 = data;

        this.current = 1;
        this.getTableData({
          page: this.current,
          pageSize: this.pageSize,
          actualType: this.actualType,
          status: this.status,
          questions_level: this.searchquestions_level,
          difficulty: this.difficulty,
          keyword: this.keyword,
        });
      }
    },
    async xiazai() {
      window.open(
        `${this.uploadUrl}/fileup/downLoadImportExcel?name=question&token=${this.token}`
      );
    },
    importShow() {
      this.data1 = [];
      this.ImportReadhospitalVisible = true;
    },
    onCancel1() {
      this.ImportReadhospitalVisible = false;
      this.successNum = "-";
      this.failNum = "-";
      this.hadNum = "-";
    },
    changeSelect(value) {
      this.current = 1;
      this.actualType = value;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        actualType: this.actualType,
        status: this.status,
        questions_level: this.searchquestions_level,
        difficulty: this.difficulty,
        keyword: this.keyword,
      });
    },
    changeSelect1(value, selectedOptions) {
      this.current = 1;
      this.searchquestions_level = value;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        actualType: this.actualType,
        status: this.status,
        questions_level: this.searchquestions_level,
        difficulty: this.difficulty,
        keyword: this.keyword,
      });
    },
    changeSelect22(value) {
      this.current = 1;
      this.difficulty = value;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        actualType: this.actualType,
        status: this.status,
        questions_level: this.searchquestions_level,
        difficulty: this.difficulty,
        keyword: this.keyword,
      });
    },
    changeSelect3(value) {
      this.current = 1;
      this.status = value;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        actualType: this.actualType,
        status: this.status,
        questions_level: this.searchquestions_level,
        difficulty: this.difficulty,
        keyword: this.keyword,
      });
    },
    onSearch(value) {
      this.current = 1;
      this.keyword = value;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        actualType: this.actualType,
        status: this.status,
        questions_level: this.searchquestions_level,
        difficulty: this.difficulty,
        keyword: this.keyword,
      });
    },
    // 获取合作企业
    async getCompanyList() {
      let result = await this.$http.post("/Company/getCooperationCompanyList");
      if (result.data.status === 1) {
        this.companyData = result.data.data.data_list;
        this.company_id = this.companyData[0].id;
        this.getTableData({
          page: this.current,
          pageSize: this.pageSize,
          cooperation_company_id: this.company_id,
        });
      }
    },
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post("/QuestionBank/getList", params);
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            status: item.status,
            question: item.question,
            type: item.type,
            actualType: item.actualType,
            difficulty: item.difficulty,
            questions_Level_type: item.questions_Level_type,
            data: item,
          };
          temp.push(obj);
        });
        this.tableData = temp;
      }
    },
    // 编辑或新增
    editAndAdd(record) {
      console.log("TCL: editAndAdd -> record", record);
      this.visible = true;
      this.selectIsDisabled = false;
      if (!record.id) {
        // 新增
        this.questionId = "";
        this.title = "新增题目";
        this.$refs.formRef.initData();
        this.$nextTick(() => {
          this.$refs.formRef.form.resetFields();
        });
      } else {
        // 编辑
        this.selectIsDisabled = true;
        this.questionId = record.id;
        this.title = "编辑题目";
        let options = {};
        let temp = record.data.options;
        console.log("editAndAdd -> temp", temp);
        if (temp) {
          temp.forEach((item) => {
            options[item.key] = {
              value: item.value,
            };
          });
        } else {
          options = undefined;
        }
        console.log("options", options);
        this.$refs.formRef.updateData(temp, String(record.data.type));
        this.$nextTick(() => {
          let data = {
            type: String(record.data.type),
            question: record.data.question,
            questions_level: record.data.questions_level,
            difficulty: record.data.difficulty,
            answer: record.data.answer,
            analysis: record.data.analysis,
            provenance: record.data.provenance,
            uniformity: record.data.uniformity,
            score: record.data.score,
            knowledge1: record.data.knowledge1,
            knowledge2: record.data.knowledge2,
            knowledge3: record.data.knowledge3,
            knowledge4: record.data.knowledge4,
            knowledge5: record.data.knowledge5,
            knowledge6: record.data.knowledge6,
            ...options,
          };
          console.log(data);
          this.$refs.formRef.form.setFieldsValue(data);
        });
      }
    },
    // 确定编辑或新增
    onSubmit() {
      this.$refs.formRef.form.validateFields(async (err, values) => {
        console.log("TCL: onSubmit -> values", values);
        if (!err) {
          let value = [];
          Object.values(values).forEach((item, index) => {
            console.log(Object.prototype.toString.call(item));
            if (Object.prototype.toString.call(item) === "[object Object]") {
              value.push({
                ...item,
                key: Object.keys(values)[index],
              });
            }
          });
          let data = {
            options: value,
            type: values.type,
            question: values.question,
            difficulty: values.difficulty,
            answer: values.answer,
            questions_level: values.questions_level,
            analysis: values.analysis,
            uniformity: values.uniformity,
            score: values.score,
            provenance: values.provenance,
            knowledge1: values.knowledge1,
            knowledge2: values.knowledge2,
            knowledge3: values.knowledge3,
            knowledge4: values.knowledge4,
            knowledge5: values.knowledge5,
            knowledge6: values.knowledge6,
          };
          this.btnIsLoading = true;
          let result = await this.$http.post("/QuestionBank/update", {
            ...data,
            id: this.questionId,
            cooperation_company_id: this.company_id,
          });
          this.btnIsLoading = false;
          if (result.data.status === 1) {
            this.$message.success("操作成功！");
            this.visible = false;
            this.getTableData({
              page: this.current,
              pageSize: this.pageSize,
              actualType: this.actualType,
              status: this.status,
              questions_level: this.searchquestions_level,
              difficulty: this.difficulty,
              keyword: this.keyword,
            });
          }
        }
      });
    },
    // 取消编辑或新增
    onCancel() {
      this.visible = false;
    },
    // 禁用 启用
    async onConfirm(record) {
      let result = await this.$http.post("/QuestionBank/setStatus", {
        id: record.id,
        status: record.status === 1 ? 0 : 1,
      });
      if (result.data.status === 1) {
        this.$message.success("操作成功！");
        this.getTableData({
          page: this.current,
          pageSize: this.pageSize,
          actualType: this.actualType,
          status: this.status,
          questions_level: this.searchquestions_level,
          difficulty: this.difficulty,
          keyword: this.keyword,
        });
      }
    },
    // 删除
    async onDelete(record) {
      let result = await this.$http.post("/QuestionBank/setStatus", {
        id: record.id,
        status: -1,
      });
      if (result.data.status === 1) {
        this.$message.success("操作成功！");
        this.getTableData({
          page: this.current,
          pageSize: this.pageSize,
          actualType: this.actualType,
          status: this.status,
          questions_level: this.searchquestions_level,
          difficulty: this.difficulty,
          keyword: this.keyword,
        });
      }
    },
    // 分页
    changePage(pagination) {
      this.current = pagination.current;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        actualType: this.actualType,
        status: this.status,
        questions_level: this.searchquestions_level,
        difficulty: this.difficulty,
        keyword: this.keyword,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
  }
}

/deep/.ant-select-selection--single {
  border-radius: 15px;
}
/deep/.yc .ant-table-tbody > tr > td {
  padding: 10px 4px !important;
}
/deep/.yc .ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  padding-left: 4px !important;
  padding-right: 4px !important;
}
</style>
<style lang="scss">
.table-search-container1 {
  height: 70px;
  line-height: 70px;

  .ant-input {
    border-radius: 15px;
    height: 30px;
  }
}
</style>
